import React from 'react';
import TMMButton, { TMMButtonProps } from '../../TMMButton';

export interface PageButtonProps extends Omit<TMMButtonProps, 'id'> {}

const PageButton: React.FC<PageButtonProps> = (props) => {
  return <TMMButton {...props} />;
};

export default React.memo(PageButton);
